import { render } from "./DjNumberControlTab.vue?vue&type=template&id=acab88bc&scoped=true"
import script from "./DjNumberControlTab.vue?vue&type=script&lang=js"
export * from "./DjNumberControlTab.vue?vue&type=script&lang=js"

import "./DjNumberControlTab.vue?vue&type=style&index=0&id=acab88bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-acab88bc"

export default script